var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_5492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69844 6.65161H7.63203C8.84609 6.65161 9.83281 7.63599 9.83281 8.85005C9.83281 10.0641 8.84844 11.0485 7.63203 11.0485H2.69844C1.48438 11.0485 0.5 10.0641 0.5 8.85005C0.5 7.63599 1.48438 6.65161 2.69844 6.65161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16641 5.52654C6.42976 5.52654 7.45391 4.50239 7.45391 3.23904C7.45391 1.97569 6.42976 0.951538 5.16641 0.951538C3.90305 0.951538 2.87891 1.97569 2.87891 3.23904C2.87891 4.50239 3.90305 5.52654 5.16641 5.52654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4118 4.93824L11.336 3.86246L12.4118 2.78668C12.529 2.66949 12.529 2.4773 12.4118 2.36011C12.2946 2.24293 12.1024 2.24293 11.9852 2.36011L10.9095 3.43824L9.83367 2.36011C9.71883 2.24058 9.52664 2.23589 9.40711 2.35074C9.28758 2.46558 9.28289 2.65777 9.39774 2.7773C9.40008 2.77964 9.40477 2.78433 9.40711 2.78668L10.4829 3.86246L9.40711 4.94058C9.28992 5.05777 9.28758 5.24996 9.40477 5.36714C9.52195 5.48433 9.71414 5.48668 9.83133 5.36949C9.83133 5.36949 9.83133 5.36949 9.83367 5.36714L10.9095 4.29136L11.9852 5.36714C12.1024 5.48433 12.2946 5.48433 12.4118 5.36714C12.5313 5.24527 12.5313 5.05543 12.4118 4.93824Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_5492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.90b24f84b3bec43d4de47ea5e64d2cbe.svg";
export { ForwardRef as ReactComponent };